import { cn } from '@/lib/utils'
import { SidebarTrigger } from '../ui/sidebar'

interface MainHeaderProps {
  children?: React.ReactNode
  className?: string
}

export default function MainHeader({ children, className }: MainHeaderProps) {
  return (
    <div
      className={cn(
        'mb-2 flex !h-[50px] shrink-0 items-center gap-2 pl-4 leading-[50px]',
        className
      )}
    >
      <SidebarTrigger className='-ml-1' />
      {children}
    </div>
  )
}
